<template>
  <div class="home-page">
    <hero-section 
      title="Supply of all building materials countrywide" 
      subtitle="You require we deliver"
      cta-text="Get a Quote"
      cta-link="/contact"
    />
    
    <section class="section services-section">
      <div class="container">
        <h2 class="section-title">Our Services</h2>
        <p class="section-subtitle">We provide comprehensive transport solutions for all your building material needs</p>
        
        <div class="services-grid">
          <div class="service-card" v-for="(service, index) in services" :key="index">
            <div class="icon-container">
              <i :class="'fas fa-' + service.icon"></i>
            </div>
            <h3>{{ service.title }}</h3>
            <p>{{ service.description }}</p>
          </div>
        </div>
        
        <div class="text-center mt-4">
          <router-link to="/services" class="btn">View All Services</router-link>
        </div>
      </div>
    </section>
    
    <section class="section testimonials-section">
      <div class="container">
        <h2 class="section-title">What Our Clients Say</h2>
        <div class="testimonials-grid">
          <testimonial-card
            v-for="(testimonial, index) in testimonials"
            :key="index"
            :name="testimonial.name"
            :company="testimonial.company"
            :testimonial="testimonial.text"
          />
        </div>
      </div>
    </section>
    
    <section class="section cta-section">
      <div class="container">
        <h2>Ready to get started?</h2>
        <p>Contact us today for reliable building materials transport</p>
        <router-link to="/contact" class="btn btn-lg">Request a Quote</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import HeroSection from '@/components/layout/HeroSection.vue';
import TestimonialCard from '@/components/home/TestimonialCard.vue';

export default {
  name: 'HomePage',
  components: {
    HeroSection,
    TestimonialCard
  },
  data() {
    return {
      services: [
        {
          title: 'Bulk Material Transport',
          description: 'Transport of sand, gravel, cement and other bulk building materials',
          icon: 'truck'
        },
        {
          title: 'Heavy Equipment Delivery',
          description: 'Safe delivery of construction equipment to your project site',
          icon: 'cog'
        },
        {
          title: 'Scheduled Deliveries',
          description: 'Regular scheduled deliveries for ongoing construction projects',
          icon: 'calendar'
        },
        {
          title: 'Emergency Transport',
          description: 'Quick response for urgent material delivery needs',
          icon: 'exclamation-triangle'
        }
      ],
      testimonials: [
        {
          name: 'John kamau',
          company: 'Jijenge ltd',
          text: 'FASA Transport has been our go-to transport partner for over 5 years. They are reliable and professional, and their service is unmatched in the industry.'
        },
        {
          name: 'Beatrice kiarie',
          company: 'Kiarie Builders',
          text: 'We\'ve worked with many transport companies, but FASA stands out with their attention to detail and commitment to timely deliveries.'
        },
        {
          name: 'oliver muli',
          company: 'Brown & Sons Contractors',
          text: 'The team at FASA Transport understands our unique needs and consistently delivers excellent service on all our projects. good communication and invoice management'
        }
      ]
    }
  }
}
</script>

<style>
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.service-card {
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
}

.icon-container {
  width: 70px;
  height: 70px;
  background-color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.icon-container i {
  font-size: 30px;
  color: white;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.section-title {
  text-align: center;
  font-size: 2.2rem;
  color: var(--secondary-color);
}

.section-subtitle {
  text-align: center;
  max-width: 700px;
  margin: 0 auto 20px;
  font-size: 1.2rem;
}

.text-center {
  text-align: center;
}

.mt-4 {
  margin-top: 30px;
}

.cta-section {
  background-color: var(--secondary-color);
  color: white;
  text-align: center;
}

.cta-section h2 {
  font-size: 2.5rem;
}

.cta-section p {
  font-size: 1.25rem;
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.btn-lg {
  font-size: 18px;
  padding: 15px 30px;
}
</style>